import { createStore } from "vuex";
// import { mockUserInfo } from "../../mock/index";
export default createStore({
  state: {
    userInfo: JSON.parse(sessionStorage.getItem("userInfo") || "{}"),
  },
  getters: {
    userInfo: (state) => state.userInfo,
  },
  mutations: {
    SET_USER_INFO(state, val) {
      state.userInfo = val;
    },
  },
  actions: {},
  modules: {},
});
